/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import {
  HelpBugRequestBusinessService,
  HelpBugRequestDialogComponent,
  HelpHttpErrorInterceptor,
} from './bug-request';
import { BuilderHelpRoutingModule } from './builder-help-routing.module';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderHelpRoutingModule,
  ],
  providers: [
    HelpBugRequestBusinessService, HelpHttpErrorInterceptor,
  ],
  declarations: [
    HelpBugRequestDialogComponent,
  ],
})

export class BuilderHelpModule {
}
